export const generateId = (): string => Math.random().toString(16).slice(2);
